import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface DeleteDedicateFlashMessageRequest extends APIRequest
{
    getMsisdn(): string;
    getId(): string;
}

export class DeleteDedicateFlashMessageRequestImpl extends APIRequestDtoImpl implements DeleteDedicateFlashMessageRequest
{
    constructor(private id: string,private msisdn: string)
    {
        super();
    }
    getMsisdn(): string {
        return this.msisdn;
    }

    getId(): string {
        return this.id;
     }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/deletededicate/deletededicateflashmessagesrequest.tsx